var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-12d7bff5"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "flex justify-end gap-2" };
const _hoisted_2 = {
    key: 0,
    style: { "display": "flex", "justify-content": "center", "align-items": "center", "height": "10vh" }
};
const _hoisted_3 = { key: 1 };
const _hoisted_4 = { class: "code-share__container" };
const _hoisted_5 = { class: "code-share__via" };
const _hoisted_6 = { class: "py-2" };
const _hoisted_7 = { class: "code-share__copy mt-3" };
import { useNotificationEvent } from '@/composable/Notification';
import { appState } from '@/composable/appState';
import { CHAT_WIDGET_IDS, CHAT_WIDGET_ROUTES, ChatType, EMIT_EVENTS, } from '@/helper/const';
import { timeAgo } from '@/helper/helper';
import { i18n } from '@/plugin/vue-i18n';
import { ChatWidgetServices } from '@/service/ChatWidgetService';
import { ArrowLeftIcon, Copy01Icon, Edit01Icon, } from '@gohighlevel/ghl-icons/24/outline';
import { UIBadge, UIButton, UIDivider, UIInput, UIModal, UIModalContent, UIModalHeader, UISpin, UITextLgMedium, UITextSmMedium, UITextXsRegular, UIToolbar, UIToolbarGroup, UITooltip, } from '@gohighlevel/ghl-ui';
import { inject, ref } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'BuilderHeader',
    props: {
        title: {
            type: String,
            default: '',
        },
        loading: {
            type: Boolean,
            default: false,
        },
        settingDefault: {
            type: Boolean,
            default: false,
        },
    },
    emits: [
        EMIT_EVENTS.SAVE_CHAT_WIDGET,
        EMIT_EVENTS.UPDATE_TITLE,
        EMIT_EVENTS.PREVIEW,
    ],
    setup(__props, { emit }) {
        const { handleError } = useNotificationEvent();
        const router = inject('router');
        const editTitle = ref(false);
        const titleRef = ref(null);
        const showModal = ref(false);
        const isGtm = ref(false);
        const showModalLoading = ref(false);
        const getCodeData = ref('');
        const showPopover = ref(false);
        const handleReturn = () => {
            if (appState.unsavedChanges)
                if (!window.confirm(i18n.global.t('builder.unsavedChangesWarning')))
                    return;
            router.push({ name: CHAT_WIDGET_ROUTES.LIST_PAGE });
        };
        const handleTitleChange = (e) => __awaiter(this, void 0, void 0, function* () {
            var _a;
            if ((_a = e.target.innerText) === null || _a === void 0 ? void 0 : _a.trim())
                emit(EMIT_EVENTS.UPDATE_TITLE, e.target.innerText);
        });
        const handleEnterPress = (e) => {
            var _a;
            if (e.key === 'Enter') {
                if (titleRef.value)
                    (_a = titleRef.value) === null || _a === void 0 ? void 0 : _a.blur();
            }
        };
        const handleGetChatWidgetCode = () => __awaiter(this, void 0, void 0, function* () {
            showModalLoading.value = true;
            try {
                if (appState.chatWidgetSettingsData.chatType === ChatType.LIVE_CHAT &&
                    appState.chatWidgetSettingsData.advanceSettings.businessOfficeHours &&
                    appState.levelUpCompany) {
                    appState.chatWidgetSettingsData.advanceSettings.businessOfficeHours.timezone =
                        appState.timeZone;
                }
                if (appState.chatWidgetSettingsData.chatType !== ChatType.LIVE_CHAT &&
                    appState.chatWidgetSettingsData.advanceSettings.contactFormOptions &&
                    appState.levelUpCompany) {
                    appState.chatWidgetSettingsData.locationCountryCode =
                        appState.locationCountryCode;
                }
                const updateChatWidget = yield ChatWidgetServices.updateChatWidget(appState.locationId, appState.chatWidgetId, {
                    settings: Object.assign({}, appState.chatWidgetSettingsData),
                });
                if (updateChatWidget.data) {
                    appState.updatedAt = updateChatWidget.data.updatedAt;
                    appState.unsavedChanges = false;
                    const getCode = yield ChatWidgetServices.getCode({
                        locationId: appState.locationId,
                        isGTM: isGtm.value,
                        widgetId: appState.chatWidgetId,
                    });
                    getCodeData.value = getCode.data.code;
                    showModalLoading.value = false;
                }
            }
            catch (error) {
                handleError(error);
                showModalLoading.value = false;
            }
            showModalLoading.value = false;
        });
        const getChatWidgetCode = (val) => {
            isGtm.value = val;
            handleGetChatWidgetCode();
        };
        const handleGetCode = () => {
            handleGetChatWidgetCode();
            showModal.value = true;
        };
        const handleWordpress = () => {
            window.open('https://wordpress.org/plugins/leadconnector/', '_blank');
        };
        const closeModal = () => {
            showModal.value = false;
        };
        const copyToClipboard = (data) => {
            navigator.clipboard.writeText(data).then(() => {
                showPopover.value = true;
                setTimeout(() => {
                    showPopover.value = false;
                }, 1000);
            });
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(_unref(UIToolbar), {
                    theme: 'light',
                    class: "h-16 bg-white text-gray-500"
                }, {
                    default: _withCtx(() => [
                        _createVNode(_unref(UIToolbarGroup), { class: "flex justify-start items-center gap-2 h-full" }, {
                            default: _withCtx(() => [
                                _createVNode(_unref(UIButton), {
                                    id: _unref(CHAT_WIDGET_IDS).HEADER_BACK_BUTTON,
                                    class: "flex flex-row gap-2 text-gray-500",
                                    onClick: handleReturn,
                                    text: ""
                                }, {
                                    default: _withCtx(() => [
                                        _createVNode(_unref(ArrowLeftIcon), { class: "w-5 h-5" }),
                                        _createVNode(_unref(UITextSmMedium), { class: "pl-2" }, {
                                            default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.$t('builder.back')), 1 /* TEXT */)
                                            ]),
                                            _: 1 /* STABLE */
                                        })
                                    ]),
                                    _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["id"]),
                                _createVNode(_unref(UIDivider), { vertical: "" }),
                                _createVNode(_unref(UITextXsRegular), null, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_unref(timeAgo)(_unref(appState).updatedAt)), 1 /* TEXT */)
                                    ]),
                                    _: 1 /* STABLE */
                                })
                            ]),
                            _: 1 /* STABLE */
                        }),
                        _createVNode(_unref(UIToolbarGroup), {
                            class: "flex flex-row justify-center gap-2 text-gray-900",
                            onClick: _cache[1] || (_cache[1] = ($event) => (editTitle.value = true)),
                            onFocusout: _cache[2] || (_cache[2] = ($event) => (editTitle.value = false))
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_unref(UITextLgMedium), null, {
                                    default: _withCtx(() => [
                                        _createElementVNode("div", {
                                            contenteditable: true,
                                            ref_key: "titleRef",
                                            ref: titleRef,
                                            onInput: handleTitleChange,
                                            onKeydown: handleEnterPress,
                                            class: _normalizeClass(`text-lg ${!editTitle.value ? 'truncate max-w-lg min-w-4' : ''}`)
                                        }, _toDisplayString(__props.title), 35 /* TEXT, CLASS, HYDRATE_EVENTS */)
                                    ]),
                                    _: 1 /* STABLE */
                                }),
                                _createVNode(_unref(UIButton), {
                                    id: _unref(CHAT_WIDGET_IDS).HEADER_EDIT_TITLE_BUTTON,
                                    onClick: _cache[0] || (_cache[0] = ($event) => { var _a, _b; ; (_b = (_a = _ctx.$refs) === null || _a === void 0 ? void 0 : _a.titleRef) === null || _b === void 0 ? void 0 : _b.focus(); }),
                                    class: "text-gray-900",
                                    text: ""
                                }, {
                                    default: _withCtx(() => [
                                        _createVNode(_unref(Edit01Icon), { class: "w-5 h-5 cursor-pointer" })
                                    ]),
                                    _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["id"])
                            ]),
                            _: 1 /* STABLE */
                        }),
                        _createVNode(_unref(UIToolbarGroup), null, {
                            default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_1, [
                                    _createVNode(_unref(UIButton), {
                                        id: _unref(CHAT_WIDGET_IDS).CHAT_WIDGET_WORDPRESS,
                                        size: "small",
                                        onClick: handleWordpress
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t('builder.getItForWordpress')), 1 /* TEXT */)
                                        ]),
                                        _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["id"]),
                                    _createVNode(_unref(UIButton), {
                                        id: _unref(CHAT_WIDGET_IDS).CHAT_WIDGET_GET_CODE_BUTTON,
                                        size: "small",
                                        onClick: handleGetCode,
                                        disabled: _unref(appState).getCodeButtonDisabled
                                    }, {
                                        default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(_ctx.$t('builder.getCode')), 1 /* TEXT */)
                                        ]),
                                        _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["id", "disabled"]),
                                    _createVNode(_unref(UIBadge), {
                                        id: "",
                                        dot: "",
                                        color: "#ef7015",
                                        show: _unref(appState).unsavedChanges,
                                        processing: ""
                                    }, {
                                        content: _withCtx(() => [
                                            _createVNode(_unref(UIButton), {
                                                size: "small",
                                                id: _unref(CHAT_WIDGET_IDS).HEADER_SAVE_BUTTON,
                                                type: "primary",
                                                disabled: !_unref(appState).unsavedChanges,
                                                loading: __props.loading,
                                                onClick: _cache[3] || (_cache[3] = ($event) => (emit(_unref(EMIT_EVENTS).SAVE_CHAT_WIDGET)))
                                            }, {
                                                default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(_ctx.$t('builder.save')), 1 /* TEXT */)
                                                ]),
                                                _: 1 /* STABLE */
                                            }, 8 /* PROPS */, ["id", "disabled", "loading"])
                                        ]),
                                        _: 1 /* STABLE */
                                    }, 8 /* PROPS */, ["show"])
                                ])
                            ]),
                            _: 1 /* STABLE */
                        })
                    ]),
                    _: 1 /* STABLE */
                }),
                _createVNode(_unref(UIModal), {
                    show: showModal.value,
                    "onUpdate:show": _cache[7] || (_cache[7] = ($event) => ((showModal).value = $event)),
                    width: 800,
                    autoFocus: false,
                    maskClosable: true,
                    onOnEsc: closeModal,
                    id: _unref(CHAT_WIDGET_IDS).MODAL_DEFAULT,
                    loading: showModalLoading.value
                }, {
                    header: _withCtx(() => [
                        _createVNode(_unref(UIModalHeader), {
                            id: _unref(CHAT_WIDGET_IDS).MODAL_HEADER,
                            type: "success",
                            title: _ctx.$t('builder.getCode'),
                            onClose: closeModal,
                            description: _ctx.$t('builder.getCodeModalDescription')
                        }, null, 8 /* PROPS */, ["id", "title", "description"])
                    ]),
                    default: _withCtx(() => [
                        _createVNode(_unref(UIModalContent), null, {
                            default: _withCtx(() => [
                                (showModalLoading.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                        _createVNode(_unref(UISpin), { size: "large" })
                                    ]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                        _createElementVNode("div", _hoisted_4, [
                                            _createElementVNode("div", _hoisted_5, [
                                                _createElementVNode("div", {
                                                    class: _normalizeClass(["code-share__via-btn", { active: !isGtm.value }]),
                                                    onClick: _cache[4] || (_cache[4] = ($event) => (getChatWidgetCode(false)))
                                                }, _toDisplayString(_ctx.$t('builder.viaCode')), 3 /* TEXT, CLASS */),
                                                _createElementVNode("div", {
                                                    class: _normalizeClass(["code-share__via-btn", { active: isGtm.value }]),
                                                    onClick: _cache[5] || (_cache[5] = ($event) => (getChatWidgetCode(true)))
                                                }, _toDisplayString(_ctx.$t('builder.viaGtm')), 3 /* TEXT, CLASS */)
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_6, [
                                            _createVNode(_unref(UIInput), {
                                                id: _unref(CHAT_WIDGET_IDS).CHAT_WIDGET_LABEL_INPUT,
                                                modelValue: getCodeData.value,
                                                type: "textarea",
                                                readonly: true,
                                                rows: 10,
                                                clearable: false,
                                                size: "large"
                                            }, null, 8 /* PROPS */, ["id", "modelValue"]),
                                            _createElementVNode("div", _hoisted_7, [
                                                _createVNode(_unref(UITooltip), {
                                                    placement: "top",
                                                    show: showPopover.value,
                                                    trigger: "manual"
                                                }, {
                                                    trigger: _withCtx(() => [
                                                        _createVNode(_unref(UIButton), {
                                                            id: _unref(CHAT_WIDGET_IDS).CHAT_WIDGET_BUTTON,
                                                            onClick: _cache[6] || (_cache[6] = ($event) => (copyToClipboard(getCodeData.value))),
                                                            type: "primary"
                                                        }, {
                                                            default: _withCtx(() => [
                                                                _createVNode(_unref(Copy01Icon), { class: "w-6" }),
                                                                _createTextVNode("  " + _toDisplayString(_ctx.$t('builder.copy')), 1 /* TEXT */)
                                                            ]),
                                                            _: 1 /* STABLE */
                                                        }, 8 /* PROPS */, ["id"])
                                                    ]),
                                                    default: _withCtx(() => [
                                                        _createTextVNode(" Copied! ")
                                                    ]),
                                                    _: 1 /* STABLE */
                                                }, 8 /* PROPS */, ["show"])
                                            ])
                                        ])
                                    ]))
                            ]),
                            _: 1 /* STABLE */
                        })
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["show", "id", "loading"])
            ], 64 /* STABLE_FRAGMENT */));
        };
    }
});
